import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

const BadgeImage = ({ image }) => (
  <GatsbyImage
    className="footer-badge"
    alt={image.description || image.title || 'Badge'}
    image={image.gatsbyImageData}
  />
);

export default function Badge({ url, image }) {
  return (
    <div className="badge">
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          aria-label={image.description || image.title || 'Badge'}
        >
          <BadgeImage image={image} />
        </a>
      ) : (
        <BadgeImage image={image} />
      )}
    </div>
  );
}
